<template>
  <el-form-item prop="imgCode">
    <el-input v-model="loginForm.imgCode" style="width:225px;" placeholder="请输入验证码" autocomplete="off" @change="receivedCode" /><el-image
      v-if="codeImgtel"
      style="width: 94px; height: 40px;float: right"
      :src="codeImgtel"
      @click="getImg"
    />
  </el-form-item>
</template>
<script>
import { defaultImg } from '@/api/user'
export default {
  name: 'CodeImg',
  data: function() {
    return {
      loginForm: {
        imgCode: null
      },
      codeImgtel: null
    }
  },
  created() {
    this.getImg()
  },
  methods: {
    getImg() {
      const param = {
        loginIP: sessionStorage.getItem('ip')
      }
      defaultImg(param).then(res => {
        this.codeImgtel = res.data.captchaImg
        sessionStorage.setItem('captchaId', res.data.captchaId)
      })
    },
    receivedCode() {
      this.$emit('receiveCode', this.loginForm.imgCode)// 将值绑定到receiveCode上传递过去
    }
  }
}
</script>
<style></style>
